import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useT } from "@/context/I18nContext";

export default function StudentConfirm() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const { locale } = useT();
  const [state, setState] = useState({ status: "loading", email: null, msg: null });

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState({ status: "error", msg: "Missing token" }); return; }
    api.get(`/student/confirm?token=${encodeURIComponent(token)}`)
      .then(({ data }) => setState({ status: "ok", email: data.email }))
      .catch((err) => setState({ status: "error", msg: err?.response?.data?.detail || "Error" }));
  }, [params]);

  return (
    <div className="min-h-screen text-slate-100">
      <Navbar />
      <main className="mx-auto max-w-lg px-4 py-16">
        <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-8 text-center">
          {state.status === "loading" ? (
            <>
              <Loader2 className="mx-auto h-12 w-12 animate-spin text-cyan-300" />
              <p className="mt-4 text-slate-300">{locale === "en" ? "Verifying..." : "Verifica in corso..."}</p>
            </>
          ) : state.status === "ok" ? (
            <>
              <CheckCircle2 data-testid="student-verified-icon" className="mx-auto h-16 w-16 text-emerald-300" />
              <h1 className="mt-4 text-2xl font-bold">
                {locale === "en" ? "Student discount activated!" : "Sconto studenti attivato!"}
              </h1>
              <p className="mt-2 text-slate-300">
                {locale === "en"
                  ? `The 20% discount is now available when you check out with ${state.email}.`
                  : `Lo sconto del 20% ora e disponibile al checkout con ${state.email}.`}
              </p>
              <Button onClick={() => nav("/#pricing")} data-testid="student-shop-btn" className="mt-6 w-full bg-emerald-400 text-slate-950 hover:bg-emerald-300">
                {locale === "en" ? "See plans" : "Vedi i piani"}
              </Button>
            </>
          ) : (
            <>
              <XCircle className="mx-auto h-16 w-16 text-red-400" />
              <h1 className="mt-4 text-2xl font-bold">{locale === "en" ? "Verification failed" : "Verifica fallita"}</h1>
              <p className="mt-2 text-slate-400">{state.msg}</p>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
